export default __webpack_public_path__ + "static/media/imgLeft_Mobile.51a94151.png";